import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { trackScreen, trackPageLoad } from '../utils/analytics';

/**
 * Reports which screen a family is on, and how long the page took to load.
 *
 * A single-page app loads once and then changes screen without the browser noticing, so without
 * this every family would be recorded as having visited exactly one page — the one they landed
 * on — and nothing about where they went, or where they stopped.
 *
 * Renders nothing. It sits inside the router so it can see the current location.
 */
const AnalyticsTracker = () => {
    const { pathname } = useLocation();
    const lastReported = useRef(null);

    // Once for the visit, not once per screen.
    useEffect(() => { trackPageLoad(); }, []);

    useEffect(() => {
        // React 18 runs effects twice in development, and a redirect can land on the same path
        // twice in a row. Either would count one screen as two.
        if (lastReported.current === pathname) return;

        lastReported.current = pathname;
        trackScreen(pathname);
    }, [pathname]);

    return null;
};

export default AnalyticsTracker;
